import React, { useEffect, useState } from "react";
import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
// import { MyVerticallyCenteredModal } from "../../../CoreComponents/VerticallyCenteredModal";
import {
  ManageVariants,
  showMessage,
  getToken,
  formatTime
} from "../../Functionalities/Functions";
import axios from "axios";
import FilterComponent from "../../CoreComponents/FilterComponent";
import { ManageSloats } from "./Functions";
import ModalComponent from "../../CoreComponents/FilterModalComponent";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css' // Import css
import LoadingComponent from "../../CoreComponents/LoadingComponent";
import {
  is_superuser,
  franchise,
  protocol,
  works_in_franchise,
  is_back_office,
  sees_all_franchises,
} from "../../Functionalities/Config";
import { GET_API } from "../../Functionalities/APIs";

function Body(props) {
  const [data, setData] = useState({
    id: "",
    label: "",
    from_time: "",
    to_time: "",
    is_active: true,
    max_orders: 0,
    franchise: "",
    data: []
  });
  const [next, setNext] = useState("");
  const [prev, setPrev] = useState("");
  const [edit, setEdit] = useState(false);
  const [modal, setModal] = useState(false);
  const [loading, setLoading] = useState(true);
  
  const [franchiseList, setFranchiseList] = useState([]);
  const [selectedFranchise, setSelectedFranchise] = useState("");

  const clearHandler = () => {
    setData({
      ...data,
      id: "",
      label: "",
      from_time: "",
      to_time: "",
      is_active: true,
      max_orders: 0,
      franchise: sees_all_franchises ? selectedFranchise : franchise.id
    });
  };

  const getFranchise = () => {
    let params = "page_wise=false&for_dropdown=true";
    let result = GET_API("", params, "/franchise/details/");
    result.then((result) => {
      if (result && result.data) {
        setFranchiseList(result.data);
        if (result.data.length > 0) {
          setSelectedFranchise(result.data[0].id);
        }
      }
    });
  };

  useEffect(() => {
    if (sees_all_franchises) {
      getFranchise();
    } else {
      getData();
    }
  }, []);

  useEffect(() => {
    if (selectedFranchise) {
      getData();
    }
  }, [selectedFranchise]);

  const getData = () => {
    setLoading(true);
    let params = "";
    if (works_in_franchise) {
      params = `franchise=${franchise.id}`;
    } else if (is_superuser && selectedFranchise) {
      params = `franchise=${selectedFranchise}`;
    } else {
      setLoading(false);
      return;
    }

    let result = ManageSloats("", "get", "", params);
    result
      .then((result) => {
        setLoading(false);
        const slotsArray = result && result.data && Array.isArray(result.data.data) 
          ? result.data.data 
          : (result && result.data && Array.isArray(result.data.results) ? result.data.results : []);
        setData({
          ...data,
          data: slotsArray,
        });
        setNext(result.data.next || "");
        setPrev(result.data.previous || "");
      })
      .catch((err) => {
        setLoading(false);
        showMessage(
          "Loading failed",
          "danger",
          "Loading error",
          "top",
          "top-right",
          0
        );
      });
  };

  const handlePrev = () => {
    var config = {
      method: "get",
      url: prev.replace("http:", protocol.replace("//", "")),
      headers: {
        Authorization: getToken(),
      },
    };
    axios(config)
      .then(function (response) {
        const slotsArray = response.data && Array.isArray(response.data.data)
          ? response.data.data
          : (response.data && Array.isArray(response.data.results) ? response.data.results : []);
        setData({
          ...data,
          data: slotsArray,
        });
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {
      });
  };

  const handleNext = () => {
    var config = {
      method: "get",
      url: next.replace("http:", protocol.replace("//", "")),
      headers: {
        Authorization: getToken(),
      },
    };

    axios(config)
      .then(function (response) {
        const slotsArray = response.data && Array.isArray(response.data.data)
          ? response.data.data
          : (response.data && Array.isArray(response.data.results) ? response.data.results : []);
        setData({
          ...data,
          data: slotsArray,
        });
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {
      });
  };

  const editFunction = (e, sloat) => {
    if (e) e.preventDefault();
    setEdit(true);
    setData({
      ...data,
      id: sloat.id,
      label: sloat.label || sloat.name || "",
      from_time: sloat.from_time,
      to_time: sloat.to_time,
      is_active: sloat.is_active !== undefined ? sloat.is_active : true,
      max_orders: sloat.max_orders || 0,
      franchise: sloat.franchise || (sees_all_franchises ? selectedFranchise : franchise.id)
    });
  };

  return (
    <div className="content-body">
      <div className="container-fluid">
        {!loading ?
          <div className="row">
            <div className="col-xl-12 ">
              <div className="card">
                <div className="card-header border-0 pb-0 d-sm-flex d-block"></div>

                <FilterComponent
                  handleNext={handleNext}
                  handlePrev={handlePrev}
                  next={next}
                  prev={prev}
                  addItemName={is_back_office && "Add Slot"}
                  modalButton={is_back_office && true}
                />

                {sees_all_franchises && (
                  <div className="card-header d-sm-flex d-block border-bottom-0 pb-0 pt-0">
                    <div className="mr-auto pr-3">
                      <h5 className="text-black" style={{ fontSize: "16px", fontWeight: "600" }}>Franchise Scope</h5>
                    </div>
                    <div className="form-group mb-0">
                      <select
                        className="form-control default-select style-1"
                        style={{ minWidth: 220, borderRadius: "8px" }}
                        value={selectedFranchise}
                        onChange={(e) => setSelectedFranchise(e.target.value)}
                      >
                        {franchiseList.map((f) => (
                          <option key={f.id} value={f.id}>
                            {f.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                )}

                <div className="card-body ">
                  <table className="table table-responsive-md">
                    <thead>
                      <tr>
                        <th>SLOT ID</th>
                        <th>SLOT NAME</th>
                        <th>MAX ORDERS</th>
                        <th>STATUS</th>
                        {is_back_office && <th>ACTION</th>}
                      </tr>
                    </thead>
                    <tbody>
                      {" "}

                      <div
                        className="modal fade"
                        id="sendMessageModal"
                      >
                        <div
                          className="modal-dialog modal-dialog-centered"
                          role="document"
                        >
                          <div className="modal-content" style={{ borderRadius: "15px" }}>
                            <div className="card-header">
                              <h4 className="card-title">
                                <>{edit ? "Edit" : "Add"} Slot</>
                              </h4>
                            </div>

                            <div className="modal-body">
                              <form className="comment-form">
                                <div className="row">
                                  <div className="col-12">
                                    <div className="form-group row align-items-center">
                                      <div className="col-sm-6 mb-3">
                                        <label className="text-black font-w500">Slot Label</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          style={{ borderRadius: "8px" }}
                                          value={data.label || ""}
                                          onChange={(e) =>
                                            setData({
                                              ...data,
                                              label: e.target.value,
                                            })
                                          }
                                        />
                                      </div>
                                      {sees_all_franchises && (
                                        <div className="col-sm-6 mb-3">
                                          <label className="text-black font-w500">Franchise</label>
                                          <select
                                            className="form-control"
                                            style={{ borderRadius: "8px" }}
                                            value={data.franchise || ""}
                                            onChange={(e) =>
                                              setData({
                                                ...data,
                                                franchise: e.target.value,
                                              })
                                            }
                                          >
                                            <option value="">Select Franchise</option>
                                            {franchiseList.map((f) => (
                                              <option key={f.id} value={f.id}>
                                                {f.name}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                      )}
                                      <div className="col-sm-6 mb-3">
                                        <label className="text-black font-w500">From time</label>
                                        <input
                                          type="time"
                                          className="form-control"
                                          style={{ borderRadius: "8px" }}
                                          value={data.from_time || ""}
                                          onChange={(e) =>
                                            setData({
                                              ...data,
                                              from_time: e.target.value,
                                            })
                                          }
                                        />
                                      </div>
                                      <div className="col-sm-6 mb-3">
                                        <label className="text-black font-w500">To time</label>
                                        <input
                                          type="time"
                                          className="form-control"
                                          style={{ borderRadius: "8px" }}
                                          value={data.to_time || ""}
                                          onChange={(e) =>
                                            setData({
                                              ...data,
                                              to_time: e.target.value,
                                            })
                                          }
                                        />
                                      </div>
                                      <div className="col-sm-6 mb-3">
                                        <label className="text-black font-w500">Max Orders (Capacity)</label>
                                        <input
                                          type="number"
                                          min="0"
                                          className="form-control"
                                          style={{ borderRadius: "8px" }}
                                          value={data.max_orders || 0}
                                          onChange={(e) =>
                                            setData({
                                              ...data,
                                              max_orders: e.target.value,
                                            })
                                          }
                                        />
                                      </div>
                                      <div className="col-sm-6 mb-3" style={{ display: 'flex', alignItems: 'center', marginTop: 25 }}>
                                        <div className="form-check">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="isActiveCheckbox"
                                            checked={data.is_active !== undefined ? data.is_active : true}
                                            onChange={(e) =>
                                              setData({
                                                ...data,
                                                is_active: e.target.checked,
                                              })
                                            }
                                          />
                                          <label className="form-check-label text-black" htmlFor="isActiveCheckbox">
                                            Active Status
                                          </label>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="form-group row mt-3">
                                      <div className="col-sm-12 text-center">
                                        <button
                                          data-dismiss="modal"
                                          className="btn btn-primary mr-1"
                                          style={{ borderRadius: "8px" }}
                                          onClick={(e) => {
                                            e.preventDefault();
                                            clearHandler();
                                            setEdit(false);
                                          }}
                                        >
                                          Close
                                        </button>
                                        {edit ? (
                                          <button
                                            data-dismiss="modal"
                                            className="btn btn-primary"
                                            style={{ borderRadius: "8px" }}
                                            onClick={(e) => {
                                              e.preventDefault();
                                              if (!data.label || data.label.trim() === "") {
                                                showMessage("Slot label is required", "danger", "Error!", "top", "top-right", 0);
                                                return;
                                              }
                                              const submitData = {
                                                ...data,
                                                franchise: data.franchise || (sees_all_franchises ? selectedFranchise : franchise.id)
                                              };
                                              let res = ManageSloats(
                                                e,
                                                "update",
                                                submitData
                                              );
                                              setModal(false);

                                              res.then((res) => {
                                                if (res && (res.data?.Status === true || res.data?.status === true)) {
                                                  showMessage("Slot updated", "success", "Success!", "top", "top-right", 0);
                                                  window.location.reload();
                                                } else {
                                                  showMessage(res?.data?.Error || res?.data?.message || "Update failed", "danger", "Error!", "top", "top-right", 0);
                                                }
                                              }).catch(err => {
                                              });
                                            }}
                                          >
                                            Save
                                          </button>
                                        ) : (
                                          <button
                                            data-dismiss="modal"
                                            className="btn btn-primary"
                                            style={{ borderRadius: "8px" }}
                                            onClick={(e) => {
                                              e.preventDefault();
                                              if (!data.label || data.label.trim() === "") {
                                                showMessage("Slot label is required", "danger", "Error!", "top", "top-right", 0);
                                                return;
                                              }

                                              const submitData = {
                                                ...data,
                                                franchise: data.franchise || (sees_all_franchises ? selectedFranchise : franchise.id)
                                              };
                                              let res = ManageSloats(
                                                e,
                                                "add",
                                                submitData
                                              );
                                              setModal(false);
                                              res.then((res) => {
                                                if (res && (res.data?.Status === true || res.data?.status === true)) {
                                                  showMessage("Slot added", "success", "Success!", "top", "top-right", 0);
                                                  window.location.reload();
                                                } else {
                                                  showMessage(res?.data?.Error || res?.data?.message || "Add failed", "danger", "Error!", "top", "top-right", 0);
                                                }
                                              }).catch(err => {
                                              });
                                            }}
                                          >
                                            Add
                                          </button>
                                        )}{" "}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>

                      {data.data.length > 0 &&
                        data.data.map((varient, index) => {
                          return (
                            <tr key={varient.id}>
                              <td>
                                <h5 className="mb-0 fs--1"> FDRSLT{varient.id}</h5>
                              </td>
                              <td>
                                <div className="d-flex align-items-center">
                                  <span className="w-space-no">
                                    {varient.label || varient.name} - {formatTime(varient.from_time)} to {formatTime(varient.to_time)}
                                  </span>
                                </div>
                              </td>
                              <td>
                                <span>{varient.max_orders || 0}</span>
                              </td>
                              <td>
                                <span className={`badge ${varient.is_active ? 'badge-success' : 'badge-danger'}`} style={{ borderRadius: "6px" }}>
                                  {varient.is_active ? "Active" : "Inactive"}
                                </span>
                              </td>
                              <td>
                                <div className="d-flex">
                                  <div className="form-group row mb-0">
                                    <div className="col-sm-9">
                                      <p className="mb-0">
                                        <a
                                          href="javascript:void(0)"
                                          data-toggle="modal"
                                          data-target="#sendMessageModal"
                                          onClick={(e) =>
                                            editFunction(e, varient)
                                          }
                                        >
                                          {is_back_office && 
                                          <span
                                            className="btn btn-primary shadow btn-xs sharp mr-1"
                                          >
                                            <i className="fa fa-pencil"></i>
                                          </span>
                                          }
                                        </a>
                                      </p>

                                    </div>
                                  </div>

                                  <div
                                    onClick={(e) => {
                                      e.preventDefault();

                                      confirmAlert({
                                        customUI: ({ onClose }) => {
                                          return (
                                            <div className='custom-ui' style={{ borderRadius: 8, border: 'solid', padding: 70, borderWidth: 0.5, backgroundColor: 'white' }}>
                                              <h1>Are you sure?</h1>
                                              <p>You want to delete ?</p>
                                              <button onClick={onClose} className="btn btn-primary" style={{ marginRight: 10, }}>Cancel</button>
                                              
                                              <button
                                                onClick={() => {
                                                  let res = ManageSloats(
                                                    e,
                                                    "delete",
                                                    "",
                                                    `id=${varient.id}`
                                                  );
                                                  setModal(false);
                                                  res.then((res) => {
                                                    if (res && (res.data?.Status === true || res.data?.status === true)) {
                                                      showMessage("Slot deleted", "success", "Success!", "top", "top-right", 0)
                                                      window.location.reload()
                                                    } else {
                                                      showMessage(res?.data?.Error || res?.data?.message || "Delete failed", "danger", "Error!", "top", "top-right", 0)
                                                    }
                                                  }).catch(err => {
                                                  })

                                                }}
                                                className="btn btn-primary"
                                              >
                                                Delete
                                                </button>
                                            </div>
                                          );
                                        }
                                      });

                                    }}
                                  >
                                    {is_back_office && 
                                    <span className="btn btn-danger shadow btn-xs sharp">
                                      <i className="fa fa-trash" />
                                    </span>
                                    }
                                  </div>
                                </div>
                              </td>
                            </tr>
                          );
                        })}{" "}
                    </tbody>

                  </table>
                </div>
              </div>
            </div>
          </div>
          : <LoadingComponent />}
      </div>
    </div>
  );
}

function Sloat() {
  const headers = "";
  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header
          name={"Slots"}
          subHeading={""}
        />
        <NavBar />{" "}
        {/* <Body bo={boln} na={name} nu={num} ar={ary} ob={obj} ao={aryobj} /> */}
        <Body />
        <Footer />
      </div>
    </div>
  );
}

export default Sloat;
